import React, { useState } from "react";
import Form from "./Form";
import { apiUrl } from "../../../utils/apiUrl";
import { toast } from "../../../utils/helpers";
import { postRequest } from "../../../utils/request";
import Modal from "../../general/Modal";

const Edit = ({getUsers, filters, toggle, sucursales, usuario, onDeleteVendedor, almacenes, cuentas}) => {
    const [errors, setErrors] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteUser, setDeleteUser] = useState({});

    const editUser = async event => {
        event.preventDefault();

        const data = new FormData(event.target);
        const { es_vendedor, empleado_id, ...rest } = Object.fromEntries(data.entries());


        if (es_vendedor && !empleado_id) {
            toast('Empleado es requerido', 'error');
            return
        }

        if (!rest['sucursales[]']) {
                toast('Sucursales es requerido', 'error');
            return
        }

        const callback =  async () => {
            const response = await postRequest(apiUrl(`usuarios/${usuario.id}`), data);
                if (response.success) {
                    let query = Object.keys(filters).map((fil) => {
                    return `${fil}=${filters[fil]}`;
                });

                getUsers("usuarios?limit=15&" + query.join("&"));
                toggle();
                toast("Usuario Actualizado.");
                return true
            }

            if (response.code === 422) {
                setErrors(response.data.message);
            }

            return false;
        };

        if (usuario.es_vendedor && !es_vendedor) {
            onDeleteVendedor(usuario, callback);
            return;
        }
        
        await callback();
    };

    const openDeleteModal = (event, usuario) => {
        event.preventDefault();

        setDeleteUser(usuario);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setDeleteUser({});
        setShowDeleteModal(false);
    };
    
    const deleteUsuario = async (usuario_id) => {
        const callback = async () => {
            const url = `usuarios/${usuario_id}`;

            const response = await postRequest(apiUrl(url), {}, 'delete');

            if (response.success) {
                let query = Object.keys(filters).map((fil) => {
                    return `${fil}=${filters[fil]}`;
                });

                getUsers("usuarios?limit=15&" + query.join("&"));
                closeDeleteModal();
                toggle();
                toast("Usuario borrado.");
                return true;
            } else {
                toast(response.data, "error");
            }

            return false;
        };

        const rol = usuario?.rol ? (usuario.rol === 'personalizado' ? null : usuario?.rol) : null;
        const esVendedor = rol ? (rol.includes("vendedor") || rol.includes("cobrador")) : (usuario?.es_vendedor || false);

        if (esVendedor) {
            onDeleteVendedor(usuario, callback);
            return;
        }

        await callback();
    };

    return (<>
        <form method='post' onSubmit={editUser}>
            <input type='hidden' name='_method' value='patch' />
            <div className='popup__header pretty'>
                <div className="d-flex w-100">
                    Editar Usuario

                    <button
                        type='button'
                        className='btn float-left my-auto ml-auto'
                        onClick={toggle}>
                        <i className="fas fa-times" style={{color: '#777'}}></i>
                    </button>
                </div>
            </div>
            <div className='popup__body pretty'>
                <Form usuario={usuario} errors={errors} sucursales={sucursales} almacenes={almacenes} cuentas={cuentas} />
            </div>
            <div className='popup__footer'>
                <button
                    type='button'
                    className='btn float-left text-danger'
                    onClick={e => openDeleteModal(e, usuario)}>
                    <i className='fas fa-trash-alt'></i>
                </button>
                <button
                    type='button'
                    onClick={toggle}
                    className='btn btn-plain btn-pretty'>
                    Cancelar
                </button>
                <button type='submit' className='btn btn-primary btn-pretty'>
                    Guardar
                </button>
            </div>
        </form>

        <Modal
            title="Eliminar Usuario"
            show={showDeleteModal}
            callback={() => deleteUsuario(deleteUser.id)}
            acceptText="Aceptar"
            toggle={closeDeleteModal}
        >
            ¿Estás seguro de que deseas eliminar el usuario `{usuario.usuario}` de `{usuario.nombre} {usuario.apellido}`? (Esta acción
            no se puede deshacer).
        </Modal>
    </>);
};

export default Edit;
